import { useEffect, useRef } from 'react'
import { SliderIndicatorProps } from './SliderIndicator.types'

const SliderIndicator: React.FC<SliderIndicatorProps> = ({
  total,
  activeIndex,
  onIndicatorClick,
}) => {
  const scrollerRef = useRef<HTMLDivElement>(null)
  const activeRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const scroller = scrollerRef.current
    const active = activeRef.current
    if (!scroller || !active) return

    // Short bars fit entirely, so there is nothing to follow.
    if (scroller.scrollWidth <= scroller.clientWidth) return

    const scrollerRect = scroller.getBoundingClientRect()
    const activeRect = active.getBoundingClientRect()

    // Centre the active bar. scrollIntoView is avoided: it also pans ancestors.
    const delta =
      activeRect.left -
      scrollerRect.left -
      (scrollerRect.width - activeRect.width) / 2

    scroller.scrollBy({ left: delta, behavior: 'smooth' })
  }, [activeIndex, total])

  return (
    // The bar grows with the draw count; scroll it here so it can never widen the page.
    <div
      ref={scrollerRef}
      className="w-full overflow-x-auto overflow-y-hidden overscroll-x-contain scrollbar-none"
    >
      <div className="flex h-2 w-max items-center mx-auto">
        {Array.from({ length: total }).map((_, index) => {
          const isActive = index + 1 === activeIndex

          return (
            <div
              key={index}
              ref={isActive ? activeRef : null}
              onClick={() => onIndicatorClick?.(index)}
              className={`h-1 rounded cursor-pointer shrink-0
                  ${isActive ? 'w-8 bottom-nav-active' : 'w-4 bg-[var(--slider-bg)]'}
                  ${index !== total - 1 ? 'mr-1' : ''}
                `}
            />
          )
        })}
      </div>
    </div>
  )
}

export default SliderIndicator
